export const backArrowIcon =
  'https://nest-platform-assets.porter.in/arrow_left_default_59393211ba/arrow_left_default_59393211ba.svg';

export const pinPickupIcon =
  'https://nest-platform-assets.porter.in/pickup_map_pin_62f10677e2/pickup_map_pin_62f10677e2.svg';

export const pinDropIcon =
  'https://nest-platform-assets.porter.in/drop_map_pin_a7e1482594/drop_map_pin_a7e1482594.svg';

export const pinPickupIconDesktop =
  'https://nest-platform-assets.porter.in/Base_96fdbf0fa0/Base_96fdbf0fa0.svg';

export const pinDropIconesktop =
  'https://nest-platform-assets.porter.in/Base_6844e50567/Base_6844e50567.svg';

export const selectLocationIcon =
  'https://nest-platform-assets.porter.in/location_track_icon_130e60e7a1/location_track_icon_130e60e7a1.svg';

export const GaEventsLocationAccuracy = {
  confirmPickup: 'fe_confirm_pickup',
  confirmDrop: 'fe_confirm_drop',
  useCurrentLocationClick: 'fe_use_current_location_click',
  allowCurrentLocationClick: 'fe_allow_current_location_click',
  dontAllowCurrentLocationClick: 'fe_dont_allow_current_location_click',
  locationPermissionDenied: 'location_permission_denied',
  fePickupFieldClicked: 'fe_pickup_field_clicked',
  feDropFieldClicked: 'fe_drop_field_clicked',
  pickupSelectFromSearch: 'fe_pickup_select_from_search',
  dropSelectFromSearch: 'fe_drop_select_from_search',
  dropLocateClicked: 'fe_drop_locate_clicked',
  pickupEditClicked: 'fe_pickup_edit_clicked',
  dropEditClicked: 'fe_drop_edit_clicked',
  pickupSearchChangeClicked: 'fe_pickup_search_change_clicked',
  dropSearchChangeClicked: 'fe_drop_search_change_clicked',
  pickupLocationError: 'fe_pickup_location_error',
  dropLocationError: 'fe_drop_location_error',
  fePickupAddressSelected: 'fe_pickup_address_selected',
  feDropAddressSelected: 'fe_drop_address_selected',
  feNameFieldClicked: 'fe_name_field_clicked',
  feNameAdded: 'fe_name_added',
  fePhoneNumberFieldClicked: 'fe_phone_number_field_clicked',
  fePhoneNumberAdded: 'fe_phone_number_added',
  feUserTypeFieldClicked: 'fe_user_type_field_clicked',
  feUserTypeSelected: 'fe_user_type_selected',
  feGetEstimateButtonClicked: 'fe_get_estimate_button_clicked',
};


export const CONFIG = {
  locationAccuracyMaxAge: 60000, // 1 minute
};

export const locationDeniedIconUrl =
  'https://nest-platform-assets.porter.in/location_denied_8ecd802f4e/location_denied_8ecd802f4e.svg';
export const locationDeniedIconAlt = 'Location Permission Denied';

export const permissionDeniedTitle = 'Fetching Current Location';
export const permissionDeniedSubtext =
  'Your location permission is off. Please provide access to your location in the browser for smooth deliveries.';
export const permissionDeniedActionButton = 'Search for location';

export const zoomInIconUrl =
  'https://nest-platform-assets.porter.in/plus_473b91ebe4/plus_473b91ebe4.svg';
export const zoomInIconAlt = 'Zoom In';
export const zoomOutIconUrl =
  'https://nest-platform-assets.porter.in/_ce7881bfad/_ce7881bfad.svg';
export const zoomOutIconAlt = 'Zoom Out';

export const detectingLocationGifUrl =
  'https://nest-platform-assets.porter.in/f150ac50723be28a43d2a71f3c9b234e0e1ba7cb_9b234cd188/f150ac50723be28a43d2a71f3c9b234e0e1ba7cb_9b234cd188.gif';
export const detectingLocationTitle = 'Fetching Current Location';

export const useCurrentLocationLabel = 'Use Current Location';
export const locateOnTheMap = 'Locate on the map';
